export default __webpack_public_path__ + "static/media/priceTag.e6db6b70.svg";